import React from "react";

const tableStyle = {
  row: "flex justify-between items-center gap-2",
  headerRow: "bg-tab-header-bg text-xs",
  topRow: "text-white",
  cell: "px-4 h-[48px] flex items-center w-full",
  centerCell: "flex-1",
  otherCell: "max-w-20",
};

const RankTable = ({ data = [] }) => {
  const sortedData = data.sort((a, b) => b.count - a.count);

  return (
    <div className="w-full px-4">
      {/* Header */}
      <div
        className={`${tableStyle.row} ${tableStyle.headerRow} rounded-t border border-neutral-300 border-b-0`}
      >
        <div className={`${tableStyle.cell} ${tableStyle.otherCell}`}>S.No</div>
        <div className={`${tableStyle.cell} ${tableStyle.centerCell}`}>RA Name</div>
        <div className={`${tableStyle.cell} ${tableStyle.otherCell}`}>Count</div>
      </div>

      {/* Top Row with crown */}
      {sortedData.length > 0 && (
        <div
          className="relative -left-2 rounded-t px-2 bg-primary"
          style={{ width: "calc(100% + 16px)" }}
        >
          {/* Left triangle */}
          <div
            className="absolute left-0 -bottom-2 w-0 h-0 border-t-primary-700 border-t-[8px] border-l-white border-l-[8px]"
          />
          {/* Right triangle */}
          <div
            className="absolute right-0 -bottom-2 w-0 h-0 border-t-primary-700 border-t-[8px] border-r-white border-r-[8px]"
          />

          {/* Top row content */}
          <div
            key={sortedData[0].key} // unique key
            className={`${tableStyle.row} ${tableStyle.topRow}`}
            style={{
              boxShadow: "0px 13px 5px -10px rgba(0,0,0,0.4)",
              position: "relative",
              zIndex: 10,
            }}
          >
            <div className={`${tableStyle.cell} ${tableStyle.otherCell}`}>1.</div>
            <div className={`${tableStyle.cell} ${tableStyle.centerCell}`}>
              {sortedData[0].name}{" "}
              <span className="ml-4 material-symbols-outlined text-yellow-300">crown</span>
            </div>
            <div className={`${tableStyle.cell} ${tableStyle.otherCell} text-2xl`}>
              {sortedData[0].count}
            </div>
          </div>
        </div>
      )}

      {/* Remaining rows */}
      <div className="rounded-b border border-neutral-300 border-t-0">
        {sortedData.slice(1).map((item, index) => (
          <div key={item.key} className={`${tableStyle.row}`}>
            <div className={`${tableStyle.cell} ${tableStyle.otherCell}`}>{index + 2}</div>
            <div className={`${tableStyle.cell} ${tableStyle.centerCell}`}>{item.name}</div>
            <div className={`${tableStyle.cell} ${tableStyle.otherCell} text-2xl`}>
              {item.count}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RankTable;

